import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";
import { AuthShell, GoogleButton, inputCls } from "@/pages/Login";
import { getFirstTouch } from "@/lib/attribution";

export default function Register() {
  const { t, lang } = useI18n();
  const { setUser, applyUserLang } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name, email, password, language: lang });
      setUser(data.user);
      applyUserLang(data.user);
      const src = getFirstTouch();
      api.post("/track/user-source", { source: src.source, medium: src.medium, campaign: src.campaign }).catch(() => {});
      // OpenAI Ads conversion — fire ONCE, only after a successful new registration.
      if (window.oaiq) window.oaiq("measure", "registration_completed", { type: "customer_action" });
      nav("/onboarding");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title={t("auth.register.title")}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <input type="text" required placeholder={t("auth.name")} value={name}
          onChange={(e) => setName(e.target.value)} className={inputCls} data-testid="register-name" />
        <input type="email" required placeholder={t("auth.email")} value={email}
          onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="register-email" />
        <input type="password" required minLength={8} placeholder={t("auth.password")} value={password}
          onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="register-password" />
        {error && <p className="text-destructive text-sm" data-testid="register-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="register-submit"
          className="w-full bg-gold text-void py-3 font-medium hover:bg-gold-hover transition-colors disabled:opacity-50">
          {loading ? t("common.loading") : t("auth.register.btn")}
        </button>
      </form>
      <div className="flex items-center gap-4 my-6 text-ink-muted text-xs">
        <div className="flex-1 h-px bg-ink/10" /> {t("auth.or")} <div className="flex-1 h-px bg-ink/10" />
      </div>
      <GoogleButton />
      <p className="text-center text-sm text-ink-muted mt-8">
        {t("auth.hasaccount")}{" "}
        <Link to="/login" className="text-gold hover:text-gold-hover" data-testid="to-login">{t("auth.toLogin")}</Link>
      </p>
    </AuthShell>
  );
}
